export const GET_ALL_RESTAURANTS = 'GET_ALL_RESTAURANTS'
export const GET_BUSINESS_HOURS = 'GET_BUSINESS_HOURS'